import NiceModal from '@ebay/nice-modal-react';
import { ActionIcon, Button, Group, Table, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

import { useRemoveAIPromptTemplate } from '../../api/removeAIPromptTemplate';
import { aiPromptTemplatesTypes } from '../../types';
import { EditModal } from '../EditModal';

import { ConfirmModal } from '@/components/Modals/Confirm';
import { COLORS } from '@/utils/colors';

type Props = {
  template: aiPromptTemplatesTypes.AIPromptTemplate;
};

export const BodyRow = ({ template }: Props) => {
  const removeTemplate = useRemoveAIPromptTemplate();
  const navigate = useNavigate();

  const shortTemplate =
    template.template.length > 120
      ? `${template.template.slice(0, 120).trimEnd()}…`
      : template.template;

  return (
    <Table.Tr>
      <Table.Td>{template.aiId}</Table.Td>
      <Table.Td>
        <Text size="sm" style={{ whiteSpace: 'pre-wrap' }}>
          {shortTemplate}
        </Text>
      </Table.Td>
      <Table.Td>
        <Group gap="xs">
          <Button
            size="xs"
            onClick={() => navigate(`/ai/prompt-templates/${template.aiId}/objections`)}
          >
            Manage Objections
          </Button>
          <Tooltip label="Edit Prompt Template">
            <ActionIcon
              variant="filled"
              radius="md"
              onClick={() => NiceModal.show(EditModal, { template })}
              aria-label="Edit template"
            >
              <IconEdit color={COLORS.text} />
            </ActionIcon>
          </Tooltip>
          <Tooltip label="Remove Prompt Template">
            <ActionIcon
              variant="filled"
              color="red"
              radius="md"
              onClick={() =>
                NiceModal.show(ConfirmModal, {
                  title: `Delete prompt template (AI ID: ${template.aiId})?`,
                  onSuccess: () => removeTemplate.mutate({ _id: template._id }),
                })
              }
              aria-label="Remove template"
            >
              <IconTrash color={COLORS.text} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Table.Td>
    </Table.Tr>
  );
};
